<div class="app-select entity-selector">
  <div class="container vh-100 d-flex flex-column justify-content-center">

    <div class="row">
      <div class="col-12 text-center">
        <div class="login-header text-center pt-5">
          <img src="{{ logoUrl }}" alt="logo" height="24">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 mx-auto">
        <div class="entity-wrapper mt-4">
          <div class="row">
            <div class="col-12 mb-5 col-md-12 col-lg-12" [hidden]="!principal.user?.roles.includes(userRolesNew.SUPER_ADMIN) &&
      !principal.user?.roles.includes(userRolesNew.ADMIN) &&
      !principal.user?.roles.includes(userRolesNew.ADMIN_READ_ONLY) &&
      !principal.user?.roles.includes(userRolesNew.USER) &&
      !principal.user?.roles.includes(userRolesNew.USER_READ_ONLY)">
              <div class="app-select-group">
                <h3 class="app-select-group-title">Main Dashboard</h3>
                @if (principal.user?.roles.includes(userRolesNew.SUPER_ADMIN) || principal.user?.roles.includes(userRolesNew.ADMIN) || principal.user?.roles.includes(userRolesNew.ADMIN_READ_ONLY) || principal.user?.roles.includes(userRolesNew.USER) || principal.user?.roles.includes(userRolesNew.USER_READ_ONLY)) {
                  <button class="app-select-item mb-3" type="button" (click)="mainDashboard()">
                    <span class="app-select-item-icon" aria-hidden="true">
                      <i class="far fa-user-tie"></i>
                    </span>
                    <span class="app-select-item-label text-uppercase">Main dashboard</span>
                    <span class="app-select-item-arrow" aria-hidden="true">
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                }
                @if (principal.user?.roles.includes(userRoles.CAMPAIGN_MANAGER) || principal.user?.roles.includes(userRoles.CLIENT_SERVICE_MANAGER)) {
                  <div class="app-select-item mb-3">
                    <span class="app-select-item-icon" aria-hidden="true">
                      <i class="far fa-user-tie"></i>
                    </span>
                    <span class="app-select-item-label text-uppercase">Campaigns dashboard</span>
                    <span class="app-select-item-arrow" aria-hidden="true">
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </div>
                }
              </div>

              @if (principal.user?.roles.includes('CONTENT_OWNER')) {
                <div class="app-select-group"
                  [ngClass]="{'mt-5': principal.user?.roles.includes('ADMIN')}">
                  <h3 class="app-select-group-title">Content owner dashboard</h3>
                  @if (coLoading) {
                    <div class="data-loader">
                      <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                      </mat-spinner>
                    </div>
                  }
                  @if (contentOwners?.length && !coLoading) {
                    <div>
                      @for (co of contentOwners; track co) {
                        <div class="app-select-item mb-3">
                          <span class="app-select-item-icon" aria-hidden="true">
                            <i class="far fa-user-tie"></i>
                          </span>
                          <span class="app-select-item-label text-uppercase">{{co.name}}</span>
                          <span class="app-select-item-arrow" aria-hidden="true">
                            <i class="fas fa-chevron-right"></i>
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-12 mb-4 col-md-12 col-lg-12"
              [hidden]="!principal.user?.publisherIds || !principal.user?.publisherIds.length">
              @if (pubLoading) {
                <div class="data-loader">
                  <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                  </mat-spinner>
                </div>
              }
              @if (!pubLoading) {
                <div class="app-select-group">
                  <h3 class="app-select-group-title">Publisher Dashboards</h3>
                  @if (publishers?.length) {
                    <div>
                      @for (p of publishers; track p) {
                        <button class="app-select-item mb-3" type="button" (click)="selectPublisher(p.id, p.secondaryId)">
                          <span class="app-select-item-icon" aria-hidden="true">
                            <i class="far fa-user"></i>
                          </span>
                          <span class="app-select-item-label text-uppercase">{{p.name}}</span>
                          <span class="app-select-item-arrow" aria-hidden="true">
                            <i class="fas fa-chevron-right"></i>
                          </span>
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-5 mx-auto">
        <small class="d-block text-center text-muted mt-5 entity-bottom3">
          © 2025 {{ platformTitle }}
        </small>
      </div>
    </div>
  </div>

</div>
